import { LocationChangedActor } from "./Tracking"
import { State, MainThunkDispatch } from "../Reducers"

export function initActors() {
    const actors = [LocationChangedActor()]
    let acting = false
    return (state: State, dispatch: MainThunkDispatch) => {
        if (acting) return
        acting = true
        actors.forEach(actor => {
            actor(state, dispatch)
        })
        acting = false
    }
}
